let optimizelyWrapper: OptimizelyWrapper | undefined;

const initOptimizely = () => {
  if (optimizelyWrapper) {
    return;
  }
  if (!OPTIMIZELY_SDK_KEY) {
    return;
  }
  if (!window.ikea?.experiment?.init || !window.parent.ikea?.experiment?.init) {
    return;
  }

  const experimentInit =
    window.ikea?.experiment?.init || window.parent.ikea?.experiment?.init;

  experimentInit(OPTIMIZELY_SDK_KEY).then((wrapper) => {
    optimizelyWrapper = wrapper;
  });
};

initOptimizely();

export const handleEventInOptimizely = (eventName: string): void => {
  optimizelyWrapper?.track(eventName);
};
